import { CurrentUser } from 'libs/hooks/useCurrentUser';
import { TagKey, TagValue } from '@xbcb/shared-types';

export const isFinanceTeamUser = (currentUser: CurrentUser): boolean => {
  const { teams, businessSupportTeams } = currentUser;

  const allTeams = [...(teams ?? []), ...(businessSupportTeams?.nodes ?? [])];
  return Boolean(
    allTeams.find(({ tags }) =>
      tags.some(
        ({ key, value }: { key: string; value: string }) =>
          key === TagKey.STRATEGIC_BUSINESS_UNIT &&
          value === TagValue.CBMS_FINANCE_TEAM,
      ),
    ),
  );
};
